import { render, staticRenderFns } from "./MoleculeEditionAcademyConfiguration.vue?vue&type=template&id=22020c8c&"
import script from "./MoleculeEditionAcademyConfiguration.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports